var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7424 14.7553L16.1357 15.3682C16.1357 15.3682 14.6917 16.8239 10.7517 12.849C6.81176 8.87399 8.25575 7.41821 8.25575 7.41821L8.63708 7.03126C9.57974 6.08149 9.66908 4.55536 8.84642 3.44053L7.16643 1.16351C6.14777 -0.2165 4.18111 -0.399148 3.01446 0.77792L0.921135 2.88853C0.343806 3.473 -0.0428584 4.22795 0.00380797 5.06678C0.123807 7.21391 1.08113 11.8315 6.41976 17.219C12.0824 22.9312 17.3957 23.1585 19.5677 22.9528C20.2557 22.8879 20.853 22.5334 21.3343 22.0463L23.2277 20.136C24.5076 18.8466 24.1476 16.6345 22.5103 15.7321L19.9637 14.3264C18.889 13.7351 17.5824 13.9083 16.7424 14.7553Z",
    fill: "#E8450A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.04ad36d44cdac2724de6d3a34c1a26c4.svg";
export { ForwardRef as ReactComponent };